import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { markOfficeReady } from '@/services/office-ready';
import './globals.css';

function renderApp() {
  const container = document.getElementById('root');
  if (!container) {
    document.body.innerHTML = '<p style="padding:16px;color:red;">Root element not found</p>';
    return;
  }

  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    console.debug('[HAI Add-in] React app rendered');
  } catch (err) {
    console.error('[HAI Add-in] Failed to render:', err);
    container.innerHTML = `<p style="padding:16px;color:red;font-family:system-ui;font-size:13px;">
      Failed to render: ${err instanceof Error ? err.message : String(err)}
    </p>`;
  }
}

let rendered = false;

function safeRender() {
  if (rendered) return;
  rendered = true;
  renderApp();
}

// Try Office.onReady first; fall back after timeout or if Office is unavailable
if (typeof Office !== 'undefined' && Office.onReady) {
  console.debug('[HAI Add-in] Waiting for Office.onReady...');

  Office.onReady((info) => {
    console.debug('[HAI Add-in] Office.onReady fired, host:', info.host, 'platform:', info.platform);
    markOfficeReady();
    safeRender();
  });

  // Safety timeout: render the UI after 5s, but keep waiting for Office.js
  setTimeout(() => {
    if (!rendered) {
      console.warn('[HAI Add-in] Office.onReady did not fire within 5s, rendering anyway');
      safeRender();
    }
  }, 5000);

  // Extended timeout: resolve officeReadyPromise after 15s even if Office.onReady never fires
  setTimeout(() => {
    markOfficeReady();
  }, 15000);
} else {
  console.debug('[HAI Add-in] No Office context, rendering directly');
  markOfficeReady();
  safeRender();
}
